import { apiClient } from '@/lib/api-client'
import {
  GetAvailableSlotsResponse,
  BookInterviewRequest,
  BookInterviewResponse,
  InterviewResponse,
  SetAvailabilityRequest,
  AddAvailabilityOverrideRequest,
  InterviewerSummary,
  SubmitInterviewReviewRequest,
} from '@shared/types/api'
import { InterviewerAvailability, AvailabilityOverride } from '@shared/types/entities'

export const interviewService = {
  getAvailableSlots: async (weekStart?: string): Promise<GetAvailableSlotsResponse> => {
    const params = weekStart ? `?weekStart=${weekStart}` : ''
    return apiClient.get<GetAvailableSlotsResponse>(`/interviews/slots${params}`)
  },

  bookInterview: async (data: BookInterviewRequest): Promise<BookInterviewResponse> => {
    return apiClient.post<BookInterviewResponse>('/interviews/book', data)
  },

  getInterview: async (id: string): Promise<{ interview: InterviewResponse }> => {
    return apiClient.get<{ interview: InterviewResponse }>(`/interviews/${id}`)
  },

  cancelInterview: async (id: string, reason?: string): Promise<void> => {
    await apiClient.post(`/interviews/${id}/cancel`, { reason })
  },

  getUpcomingInterviews: async (): Promise<{ interviews: InterviewResponse[] }> => {
    return apiClient.get<{ interviews: InterviewResponse[] }>('/interviews/upcoming')
  },

  getCompletedInterviews: async (): Promise<{ interviews: InterviewResponse[] }> => {
    return apiClient.get<{ interviews: InterviewResponse[] }>('/interviews/completed')
  },

  submitReview: async (id: string, data: SubmitInterviewReviewRequest): Promise<void> => {
    await apiClient.post(`/interviews/${id}/review`, data)
  },

  getAvailability: async (interviewerId?: string): Promise<{ availability: InterviewerAvailability | null }> => {
    const params = interviewerId ? `?interviewerId=${interviewerId}` : ''
    return apiClient.get<{ availability: InterviewerAvailability | null }>(`/availability${params}`)
  },

  setAvailability: async (data: SetAvailabilityRequest): Promise<{ availability: InterviewerAvailability }> => {
    return apiClient.put<{ availability: InterviewerAvailability }>('/availability', data)
  },

  addOverride: async (data: AddAvailabilityOverrideRequest): Promise<{ override: AvailabilityOverride }> => {
    return apiClient.post<{ override: AvailabilityOverride }>('/availability/overrides', data)
  },

  listInterviewers: async (): Promise<{ interviewers: InterviewerSummary[] }> => {
    return apiClient.get<{ interviewers: InterviewerSummary[] }>('/availability/interviewers')
  },
}
